
<app-loading [loading]="showLoading" [message]="alertMessage"></app-loading>
  <div class="login-block" *ngIf="!showLoading">
    <app-logo-card></app-logo-card>
    <mat-card class="login-card">
      <mat-card-header>
        <!--      <mat-card-title class="login-title">ログイン</mat-card-title>-->
        <mat-card-title>
          パスワードを更新してください
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <form (ngSubmit)="submitLogin($event)"
              class="login-form"
              #loginForm="ngForm">

          <mat-form-field>
            <input matInput
              [type]="!show ? 'password' : 'text'"
              placeholder="パスワード"
              id="inputPassword"
              [(ngModel)]="pass.password"
              name="password"
              #password="ngModel"
              required>
            <mat-label class="form-error" color="danger" *ngIf="password.errors?.required">*必須です
            </mat-label>
            <button mat-icon-button
                    matSuffix type="button"
                    (click)="show = !show"
                    [attr.aria-label]="'Hide password'"
                    [attr.aria-pressed]="show"
            >
              <mat-icon>{{show ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
          </mat-form-field>

          <mat-form-field>
            <input matInput
              [type]="!show ? 'password' : 'text'"
              placeholder="確認のためもう一度入力して下さい"
              id="inputPassword2"
              [(ngModel)]="pass.confirmpassword"
              name="confirmpassword"
              #confirmpassword="ngModel"
              required
              [pattern]="pass.password"
            >
            <mat-label class="form-error" color="danger" *ngIf="confirmpassword.errors?.required">必須です
            </mat-label>
            <mat-label class="form-error" color="danger" *ngIf="confirmpassword.errors?.pattern">一致しません
            </mat-label>
            <button mat-icon-button
                    matSuffix type="button"
                    (click)="show = !show"
                    [attr.aria-label]="'Hide password'"
                    [attr.aria-pressed]="show"
            >
              <mat-icon>{{show ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
          </mat-form-field>
          <br>
          <br>
          <button mat-button
            type="submit"
            color="primary"
            [disabled]="loginForm.invalid"
          >
            パスワードを更新
          </button>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
